export function updatePasswordStateSelector(state) {
  return state.local.currentUser.passwordUpdate
}
